import type { DomainEventTopic } from './domain-events-stream'

type Listener = () => void

const listeners = new Map<DomainEventTopic, Set<Listener>>()

/** Wake-ups for code that isn't an RTK query, such as loops and refresh counters. */
export function onDomainTopic(topic: DomainEventTopic, listener: Listener): () => void {
  let set = listeners.get(topic)
  if (!set) {
    set = new Set()
    listeners.set(topic, set)
  }
  set.add(listener)
  return () => {
    set.delete(listener)
  }
}

export function emitDomainTopic(topic: DomainEventTopic): void {
  for (const listener of [...(listeners.get(topic) ?? [])]) listener()
}

/** Resolves on the topic's next emission, after `timeoutMs`, or when `signal` aborts. */
export function nextDomainTopic(
  topic: DomainEventTopic,
  timeoutMs: number,
  signal: AbortSignal
): Promise<void> {
  return new Promise((resolve) => {
    if (signal.aborted) {
      resolve()
      return
    }
    const done = () => {
      clearTimeout(timer)
      off()
      signal.removeEventListener('abort', done)
      resolve()
    }
    const off = onDomainTopic(topic, done)
    const timer = setTimeout(done, timeoutMs)
    signal.addEventListener('abort', done, { once: true })
  })
}
